import type { SVGProps } from 'react';

export const SvgIconClose = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.6482 3L12.0002 10.6482L4.35226 3L3 4.35182L10.6485 12L3 19.6482L4.35226 21L12.0002 13.3518L19.6482 21L21 19.6482L13.352 12L21 4.35182L19.6482 3Z"
      fill="currentColor"></path>
  </svg>
);
